import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GameTypeEnum } from "../../../enumeration/GameTypeEnum";
import { CheckIsNull } from "../../../utils/CommonHelper";
import { GameListing } from "../../common/components/GameListing";
import * as actions from "../redux/SlotAction";

export const SlotListing = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [category, setCategory] = useState("all");
  const { companyCode } = useParams();
  const [companyName, setCompanyName] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const [companyOffset, setCompanyOffset] = useState(
    location.state ? parseInt(location.state.companyOffset) : 0
  );
  const isInitial = useRef(true);
  const slotState = useSelector(({ slot }) => slot, shallowEqual);

  const fetchGameList = () => {
    const params = {
      action: "mbslotgamelistV2",
      companycode: companyCode,
      category,
    };

    dispatch(actions.getSlotGameList(params)).then(() => {
      if (location.state && isInitial.current) {
        if (document.querySelector(".outlet-wrapper"))
          document.querySelector(".outlet-wrapper").scrollTo({
            top: parseInt(location.state.scrollPosition),
            behavior: "smooth",
          });
      }
      isInitial.current = false;
    });
  };

  useEffect(() => {
    fetchGameList();
  }, [companyCode, category]);

  useEffect(() => {
    if (slotState.slotGameList) {
      const foundCompany = slotState.slotGameList.companyGameLists.find(
        (company) => company.companycode === companyCode
      );

      if (foundCompany) {
        setCompanyName(foundCompany.companyname);
      }
    }
  }, [slotState.slotGameList, companyCode]);

  const handlePlayGame = (gameCode, searchName) => {
    sessionStorage.setItem("lastSelectGame", gameCode);
    const currentScrollPosition = document.querySelector(".outlet-wrapper")
      ? document.querySelector(".outlet-wrapper").scrollTop
      : window.scrollY || document.documentElement.scrollTop;

    navigate(
      `/gamePlay/${companyCode}/${gameCode}/${companyOffset}/${currentScrollPosition}/${
        GameTypeEnum.SLOTS
      }${CheckIsNull(searchName) ? "" : `/${searchName}`}`
    );
  };

  const clearPromotion = () => {
    dispatch(actions.clearPromotion());
  };

  return (
    <GameListing
      gameCompanyList={slotState.slotGameList?.companyGameLists}
      gameCategoryList={slotState.slotGameList?.slotGameCategory}
      gameList={slotState.slotGameList?.slotGameLists}
      promotionLists={slotState.slotGameList?.promotionLists}
      activepromotionid={slotState.slotGameList?.activepromotionid}
      setCategory={setCategory}
      category={category}
      companyCode={companyCode}
      handlePlayGame={handlePlayGame}
      setCompanyOffset={setCompanyOffset}
      companyOffset={companyOffset}
      initialSearchName={location.state ? location.state.searchName : ""}
      companyName={companyName}
      gameType={"slot"}
      clearPromotion={clearPromotion}
    />
  );
};
